<template>
    <div class="news-header">
        <tag />
        <p>
            por <span>UGT-SP Notícias</span> {{ date }}
        </p>
    </div>
</template>

<script>
import Tag from "../../../../../components/tag/tag.vue";
export default {
    name: 'news-header',
    components: {Tag},
    props: {
        date: String,
    }
}
</script>

<style lang="scss" scoped>
.news-header {
    @apply flex justify-between items-center py-1 px-0;
    p {
        font-size: 12px;
        width: 100%;
        margin-left: 6px;
        text-align: right;
        span {
            @apply text-tertiary;
            font-size: 12px;
        }
    }
}

</style>
